import { render, staticRenderFns } from "./InputModal.vue?vue&type=template&id=4000cdc2&scoped=true&"
import script from "./InputModal.vue?vue&type=script&lang=js&"
export * from "./InputModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4000cdc2",
  null
  
)

export default component.exports